export const isLocalHost = () =>
  window.location.hostname === "localhost" ||
  window.location.host === "127.0.0.1"
